<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const playUnit = {
  unit: "Unit 14",
  title: "The End of the Beginning",
  to: "/11th/english/play/the-end-of-the-beginning/",
  focus: "humor, role reversal, Lizzie, domestic conflict",
  tags: ["Solved", "MCQs", "Revision"],
  stats: ["play answers", "2 MCQs", "revision points"],
};

const faqs = [
  {
    question: "Is there only one play in 11th English here?",
    answer: "Haan, 11th class English me is section me sirf Unit 14, The End of the Beginning, shamil hai.",
  },
  {
    question: "What kind of help does the play page give?",
    answer: "Play page me summary, characters, themes, short notes aur MCQs milte hain.",
  },
  {
    question: "Can I open the play directly from here?",
    answer: "Haan. Neeche diya gaya card aap ko seedha play ke page par le jata hai.",
  },
];

usePageSeo({
  title: "11th Class English Play",
  description: "11th class English play cluster for The End of the Beginning notes, questions and analysis.",
  keywords: "11th class english play, the end of the beginning notes",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: `${playUnit.unit}: ${playUnit.title}`,
          url: `https://ustaad.today${playUnit.to}`,
        },
      ],
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Play", item: "/11th/english/play/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="Play"
      description="Is section me Unit 14, The End of the Beginning, ka page diya gaya hai. Yahan se aap summary, characters, themes aur important MCQs parh sakte hain."
    />

    <EnglishSection
      title="Open the Play"
      description="Neeche card par click karke play ka page kholain."
    >
      <EnglishCard
        :title="`${playUnit.unit}: ${playUnit.title}`"
        :description="`Is play me ${playUnit.focus} par focus kiya gaya hai. Aap ko ${playUnit.stats.join(', ')} mil jayenge.`"
        :to="playUnit.to"
      />
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Play ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
